module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-08-3633842c11b8e3bd99f6cc683301692d.jpg";